import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface NotFoundStateProps {
  title?: string;
  message?: string;
}

export function NotFoundState({ title, message }: NotFoundStateProps) {
  return (
    <Box className="page-state not-found-state" role="status" sx={{ textAlign: 'center', p: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}
